export default "__VITE_ASSET__f1af82ca__"